import axios from "../../utils/axios";

export const updatePostSave = async ({isSaved, id}) => {
    const response = await axios.patch(`/blogs/${id}`, {
        isSaved: !isSaved,
      }, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });

  return response.data;
};
